import axios from 'axios';





const apiClient = axios.create({
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor
apiClient.interceptors.request.use(
  async (config) => {
    const  token  = null;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  async (error) => {
    throw error;
  }
);

// Add a response interceptor
apiClient.interceptors.response.use(
  async (response) => response,
  async (error) => {
    throw error.response ? error.response.data : error;
  }
);

export const postRequest = async (url, data, token) => {
  try {
    const response = await apiClient.post(url, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {

    throw error;
  }
};

